import {
  DotsInputDecimal,
  IDotsInputDecimalProps,
} from "dots-ui/dotsInputDecimal";
import { useMemo } from "react";
import { AvisConstants } from "../../../../data/avisConstants";

export function AvisInputDecimal<T = object>(
  props: Readonly<IDotsInputDecimalProps<T>>,
) {
  const { title, ...restProps } = props;

  const tooltipValue = useMemo(() => {
    if (title) return title;

    if (!props.bag?.values || !props.bagField) return undefined;

    const bagValue = (props.bag.values as any)[props.bagField]?.toString();

    return bagValue;
  }, [props.bag?.values, props.bagField, title]);

  return (
    <DotsInputDecimal<T>
      spacing="small"
      decimalDelimiter={AvisConstants.default_delimiter}
      decimalSymbolCount={2}
      title={tooltipValue}
      {...restProps}
      onlyPositive={props.onlyPositive ?? true}
    />
  );
}
